/**
 * Buy Now Pay Later widgets (Afterpay + Zip).
 * Keeps the displayed amount in sync with the selected variant and hides the
 * widgets when the variant price drops below the configured minimum.
 */
(() => {
  const SELECTOR = '[data-bnpl-widgets]';

  const toAmount = (cents) => (cents / 100).toFixed(2);

  const refreshZip = (container, amount) => {
    const zipEl = container.querySelector('[data-zm-merchant]');
    if (!zipEl) return;

    // The Zip widget script renders into the element once, on scan. Swap in a
    // fresh element with the new price and ask the script to scan again.
    const fresh = zipEl.cloneNode(false);
    fresh.setAttribute('data-zm-price', amount);
    zipEl.replaceWith(fresh);

    const oldScript = document.querySelector('script[src*="zip-widget.min.js"]');
    if (!oldScript) return;
    const script = document.createElement('script');
    script.src = oldScript.src;
    script.async = true;
    oldScript.replaceWith(script);
  };

  const update = (container, variant) => {
    if (!variant) {
      container.hidden = true;
      return;
    }

    const minCents = parseInt(container.dataset.bnplMinCents, 10) || 0;
    const show = variant.price >= minCents;
    const amount = toAmount(variant.price);

    if (!show) {
      container.hidden = true;
      return;
    }

    const afterpay = container.querySelector('afterpay-placement');
    if (afterpay) afterpay.setAttribute('data-amount', amount);

    const currentZipPrice = container.querySelector('[data-zm-merchant]')?.getAttribute('data-zm-price');
    if (currentZipPrice !== undefined && currentZipPrice !== amount) refreshZip(container, amount);

    container.hidden = false;
  };

  document.addEventListener('on:variant:change', (evt) => {
    const { form, variant } = evt.detail || {};
    if (!form) return;

    // Scope to the product section that fired the event (handles quick-buy too).
    const section = form.closest('.js-product') || document;
    section.querySelectorAll(SELECTOR).forEach((container) => update(container, variant));
  });
})();
